import React from 'react'
import { Drawer, DrawerHeader, DrawerContent, QuickView } from '@sainsburys-tech/bolt'

import PromotionProductPanel from './PromotionProductPanel'
import PromotionStrings from '../config/promotion-strings.json'
import { Section, SectionHeader, StyledAlert } from '../PromotionLink.styles'

class PromotionDrawer extends React.Component {
  toggleCallback = () => {
    if (this.props.show) {
      this.props.togglePromotionDrawer()
    }
  }

  formatPromotionString = (promotionString, value, productName = '') => {
    promotionString = promotionString.replace('{0}', value)
    promotionString = promotionString.replace('{1}', productName)
    return promotionString
  }

  render = () => {
    const { show, dataTest, partNumber, totalNectarPoint, promotions } = this.props
    let unknownPromoPoints = 0

    const BRAND = process.env.BRAND || 'ARGOS'

    const nectarBreakdown = promotions.reduce(
      (result, item, index) => {
        const activePromotion = PromotionStrings.activePromotions[BRAND.toLocaleLowerCase()]?.find(
          el => el.uuid === item.id
        )
        if (activePromotion) {
          result.activePromotions.push(this.formatPromotionString(activePromotion.wording, item.value))
          result.shortWordings.push(
            <li key={index}>{this.formatPromotionString(activePromotion.shortWording, item.value)}</li>
          )
        } else if (item.promotionType === PromotionStrings.strings.NECTAR_BASERATE) {
          result.shortWordings.push(
            <li key={index}>
              {this.formatPromotionString(PromotionStrings.strings.NECTAR_BASERATE_PROMOTION, item.value)}
            </li>
          )
        } else {
          unknownPromoPoints += item.value
        }
        return result
      },
      {
        activePromotions: [],
        shortWordings: []
      }
    )

    // default messaging for nectar promotions that don't have a wording.
    if (unknownPromoPoints > 0) {
      nectarBreakdown.shortWordings.push(
        <li key={0}>
          {(this, this.formatPromotionString(PromotionStrings.strings.NECTAR_POINTS_PROMOTION, unknownPromoPoints))}
        </li>
      )
    }

    const brandName = `${BRAND.charAt(0)}${BRAND.toLowerCase().substring(1)}`
    return (
      <Drawer
        position='right'
        show={show}
        onClose={() => this.toggleCallback()}
        padding={false}
        data-test={dataTest}
        ariaLabelledBy='promotion-link'
      >
        <DrawerHeader> Nectar Points </DrawerHeader>
        <DrawerContent>
          <div data-test={`${dataTest}-contents`}>
            <QuickView.ProductFetch
              fetch={show}
              partNumbers={[partNumber]}
              render={({ products, isLoading }) => (
                <PromotionProductPanel
                  isLoading={isLoading}
                  product={products[partNumber]}
                  dataTest={`${dataTest}-product-panel`}
                  totalNectarPoint={totalNectarPoint}
                />
              )}
            />
            {nectarBreakdown.activePromotions.length > 0 && (
              <StyledAlert
                kind='info'
                className='alertborder'
                isCloseable={false}
                data-test={`${dataTest}-dec-promotion`}
              >
                {nectarBreakdown.activePromotions[0]}
              </StyledAlert>
            )}
            <Section data-test={`${dataTest}-breakdown`}>
              <SectionHeader>Nectar points collected with this product</SectionHeader>
              <ul>{nectarBreakdown.shortWordings}</ul>
            </Section>
            <Section data-test={`${dataTest}-how-works`}>
              <SectionHeader>{`How Nectar works at ${brandName}`}</SectionHeader>
              {BRAND === 'HABITAT' ? (
                <ul>
                  <li>Collect 1 point for every £1 spent at Habitat.</li>
                  <li>When spending points, 500 points are worth £2.50</li>
                  <li>You can collect and spend your Nectar points online and in our showrooms.</li>
                  <li>Keep your eyes peeled for opportunities to collect bonus Nectar points.</li>
                  <li>To spend or collect points online you'll need to link your Nectar and Argos accounts.</li>
                  <li>Shopping in a showroom? No worries, just have your Nectar card to hand.</li>
                </ul>
              ) : BRAND === 'TU' ? (
                <ul>
                  <li>Collect 1 point for every £1 spent at Tu</li>
                  <li>When spending points, 500 points are worth £2.50</li>
                  <li>You can collect and spend your Nectar points online.</li>
                  <li>Keep your eyes peeled for opportunities to collect bonus Nectar points.</li>
                  <li>To spend or collect points online you'll need to link your Nectar and Argos accounts.</li>
                </ul>
              ) : (
                <ul>
                  <li>Collect 1 point for every £1 spent at Argos</li>
                  <li>When spending points, 500 points are worth £2.50</li>
                  <li>You can collect and spend your Nectar points in-store and online.</li>
                  <li>Keep your eyes peeled for opportunities to collect bonus Nectar points.</li>
                  <li>To spend or collect points online you'll need to link your Nectar and Argos accounts.</li>
                  <li>Shopping in-store? No worries, just have your Nectar card to hand at an Argos till.</li>
                </ul>
              )}
              <a href='/help/terms-and-conditions/#NectarPoints'>Terms and conditions</a>
            </Section>
          </div>
        </DrawerContent>
      </Drawer>
    )
  }
}

export default PromotionDrawer
